import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import {
  selectDefaultMessage,
  selectOfferChatDealType,
  selectOfferChatGaLabel,
  selectOfferChatOfferId,
  selectOfferChatOfferType,
  selectOfferChatProduct,
  selectShouldSendDefaultMessage,
} from 'shared/map-search/selectors/chatModal';

import { getSourceParams } from '../utils/getSourceParams';

export const useSrcChat = (isOpen: boolean) => {
  const defaultMessage = useSelector(selectDefaultMessage);
  const shouldSendDefaultMessage = useSelector(selectShouldSendDefaultMessage);
  const gaLabel = useSelector(selectOfferChatGaLabel);
  const offerId = useSelector(selectOfferChatOfferId);
  const dealType = useSelector(selectOfferChatDealType);
  const offerType = useSelector(selectOfferChatOfferType);
  const product = useSelector(selectOfferChatProduct);
  const source = getSourceParams();
  const contextToken = product?.extra?.context_token;

  return useMemo(() => {
    if (!offerId || !isOpen) {
      return null;
    }

    /* istanbul ignore next */
    const src =
      `/dialogs/?hostType=frame&offerId=${offerId}` +
      `${dealType ? `&dealType=${dealType}` : ''}` +
      `${offerType ? `&offerType=${offerType}` : ''}` +
      `${gaLabel ? '&gaLabel=' + encodeURIComponent(gaLabel) : ''}` +
      '&pageType=Listing' +
      '&listingType=map' +
      `${defaultMessage ? '&defaultMessage=' + encodeURIComponent(defaultMessage) : ''}` +
      `${shouldSendDefaultMessage ? '&sendDefaultMessage=1' : ''}` +
      `${source ? `&parentSource=${source}` : ''}` +
      `${contextToken ? '&context=' + encodeURIComponent(contextToken) : ''}`;

    return src;
  }, [dealType, defaultMessage, gaLabel, isOpen, offerId, offerType, shouldSendDefaultMessage, source, contextToken]);
};
